'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagIlAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M-2.38121e-05 -1.52588e-05L28 -3.78489e-06C28 6.66666 28 13.3333 28 20H-3.05176e-05C0.000197802 13.3333 -1.49376e-05 6.66666 -2.38121e-05 -1.52588e-05Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1.49012e-07 4H28V-3.78489e-06L-2.38121e-05 -1.52588e-05C1.18666e-05 1.33332 1.49012e-07 2.66666 1.49012e-07 4Z",
          fill: "#0E46D4"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M-3.05176e-05 20H28V16H1.49012e-07L-3.05176e-05 20Z",
          fill: "#0E46D4"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.0151 9.99999L9.53363 12.6666H12.4966L14 15.3728L15.5034 12.6666H18.4663L16.9848 9.99999L18.4663 7.33333H15.5034L14 4.62722L12.4966 7.33333L9.53363 7.33333L11.0151 9.99999ZM11.3964 10.6864L10.6666 12H12.1262L11.3964 10.6864ZM12.8889 12L11.7777 9.99999L12.8889 8H15.1111L16.2222 9.99999L15.1111 12H12.8889ZM13.2592 12.6666L14 14L14.7407 12.6666L13.2592 12.6666ZM16.6035 10.6864L15.8737 12H17.3333L16.6035 10.6864ZM16.6035 9.31361L17.3333 8H15.8737L16.6035 9.31361ZM14.7407 7.33333L14 5.99997L13.2592 7.33333H14.7407ZM12.1262 8L11.3964 9.31361L10.6666 8H12.1262Z",
          fill: "#093EC5"
        }
      )
    ]
  }
);
const VpFlagIlAsset = forwardRef(FlagIlAsset);

export { VpFlagIlAsset as default };
